module.exports = __webpack_public_path__ + "static/media/ig7.3d32a9fa.jpg";